<template>
  <div class="nav-bar">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 46px;">
      <van-nav-bar
              :title="title"
              fixed
              left-arrow
              @click-left="goUrl(url)"
      />
    </div>
  </div>
</template>

<script>
export default {
    name: 'NavBar',
    props: {
        title: String,
        url: String
    },
    methods:{
      goUrl(path) {
          return this.$router.push({path:path})
      }
    }
}
</script>

<style scoped>
/*导航*/
.nav-bar >>> .van-nav-bar {
  z-index: 9;
  background: #ff8917;
  padding-top: 6px;
}
.nav-bar >>> .van-nav-bar .van-icon {
  color: #fff;
}
.nav-bar >>> .van-nav-bar__title {
  color: #fff;
}
.nav-bar >>> .van-nav-bar__text {
  color: #fff;
}
</style>
